export const ADD_ARTICLE = "ADD_ARTICLE";
export const UPDATE_ARTICLE = "UPDATE_ARTICLE";
export const REMOVE_ARTICLE = "REMOVE_ARTICLE";
export const ACTIVE_CART = "ACTIVE_CART";
export const CLEAR_CART = "CLEAR_CART"
